import { Box } from '@mui/material';
import { FC } from 'react';
import GeneralInfoSection from './GeneralInfoSection';
import { AiFillFile } from 'react-icons/ai';
import { GoGitCommit } from 'react-icons/go';
import { BiGitBranch } from 'react-icons/bi';
import { FaCodeBranch } from 'react-icons/fa';
import { FaTags } from 'react-icons/fa';
import { FaDownload } from 'react-icons/fa';
import { FaArrowRight } from 'react-icons/fa';
import { ImEye } from 'react-icons/im';

const GitActivityContent: FC<
  React.PropsWithChildren<GitActivityContentProps>
> = ({
  pushEvents,
  pullRequests,
  Tags,
  YAMLs,
  commits,
  branches,
  analyzedBranches,
  watchers,
  downloads,
  forks,
}) => {
  return (
    <Box display='flex' p={3} gap={3} flexDirection='row' flexWrap='wrap'>
      <GeneralInfoSection
        title='Push Events'
        value={pushEvents}
        icon={FaArrowRight}
      />
      <GeneralInfoSection
        title='Pull Requests'
        value={pullRequests}
        icon={FaCodeBranch}
      />
      <GeneralInfoSection title='Tags' value={Tags} icon={FaTags} />
      <GeneralInfoSection title='YAMLs' value={YAMLs} icon={AiFillFile} />
      <GeneralInfoSection title='Commits' value={commits} icon={GoGitCommit} />
      <GeneralInfoSection
        title='Branches'
        value={branches}
        icon={FaCodeBranch}
      />
      <GeneralInfoSection
        title='Analyzed Branch'
        value={analyzedBranches}
        icon={BiGitBranch}
      />
      <GeneralInfoSection title='Watchers' value={watchers} icon={ImEye} />
      <GeneralInfoSection
        title='Downloads'
        value={downloads}
        icon={FaDownload}
      />
      <GeneralInfoSection title='Forks' value={forks} icon={FaCodeBranch} />
    </Box>
  );
};

export interface GitActivityContentProps {
  pushEvents: number;
  pullRequests: number;
  Tags: number;
  YAMLs: number;
  commits: number;
  branches: number;
  analyzedBranches: string;
  watchers: number;
  downloads: string;
  forks: number;
}

export default GitActivityContent;
